import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import config from '../config';

/**
 * Handles 301 redirects from old URLs to new slug-based URLs
 * Old: /product/Getac%20K120/6949aa56-c67c-48ce-8086-1b54f7c6c748
 * New: /p/getac-k120-core-i5-6949aa56
 */
const ProductDetailRedirect = () => {
  const { productID } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSlugAndRedirect = async () => {
      try {
        // Fetch product by old ID to get new slug
        const response = await fetch(
          `${config.baseUrl}/api/Product/GetProduct/${productID}`
        );

        if (response.redirected) {
          // API returned 301 redirect - extract slug from Location header
          const redirectUrl = response.url;
          const slugMatch = redirectUrl.match(/\/slug\/([^/?]+)/);
          
          if (slugMatch && slugMatch[1]) {
            const slug = slugMatch[1];
            // 301 redirect to new URL
            navigate(`/p/${slug}`, { replace: true });
            return;
          }
        }

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.data && data.data.slug) {
            // Redirect to new slug-based URL
            navigate(`/p/${data.data.slug}`, { replace: true });
          } else {
            // Fallback: redirect to home if no slug
            console.warn('Product found but no slug available');
            navigate('/', { replace: true });
          }
        } else {
          // Product not found - redirect to home
          console.error('Product not found:', productID);
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Error redirecting:', error);
        // Fallback to home page
        navigate('/', { replace: true });
      }
    };

    if (productID) {
      fetchSlugAndRedirect();
    }
  }, [productID, navigate]);

  // Show loading spinner while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to product page...</p>
      </div>
    </div>
  );
};

export default ProductDetailRedirect;
